module.exports = __webpack_public_path__ + "assets/faceImg.e2d3f2fb.svg";